export const TankaauthorityDivcd = {
    /** 登録 */
    create: "1",
    /** 参照 */
    read: "2",
    /** 承認 */
    approve: "3",
} as const;